import React from "react";
import { ShieldCheck, ScanEye, Building2, Tractor, MapPin } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCoastalAdvantage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "Reliable & Professional",
    subtitle: "Trusted Local Team",
    icon: <ShieldCheck className="w-8 h-8 text-primary" />
  }, {
    title: "Attention to Detail",
    subtitle: "Precision Care",
    icon: <ScanEye className="w-8 h-8 text-primary" />
  }, {
    title: "Residential & Commercial",
    subtitle: "All Property Types",
    icon: <Building2 className="w-8 h-8 text-primary" />
  }, {
    title: "Fully Equipped",
    subtitle: "Industrial Grade Gear",
    icon: <Tractor className="w-8 h-8 text-primary" />
  }, {
    title: "Servicing the Central Coast",
    subtitle: "Local Experts",
    icon: <MapPin className="w-8 h-8 text-primary" />
  }];
  return <section id="the-coastal-advantage" className="dark bg-background text-foreground py-12 md:py-20 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

      <div className="container mx-auto px-4">
        <div ref={ref} className={`
            relative rounded-2xl border border-primary/10 bg-card/5 backdrop-blur-sm
            shadow-[0_0_40px_-10px_rgba(16,185,129,0.05)]
            transition-all duration-1000 ease-out transform
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `}>
          {}
          <div className="absolute inset-0 rounded-2xl pointer-events-none shadow-[inset_0_0_60px_rgba(16,185,129,0.05)]" />

          <div className="grid grid-cols-1 md:grid-cols-5 relative z-10">
            {features.map((feature, index) => <React.Fragment key={index}>
                <div data-index={index} className="group flex flex-col items-center text-center p-6 md:p-8 transition-colors hover:bg-primary/5">
                  <div className="mb-4 p-3 rounded-full bg-primary/10 text-primary ring-1 ring-primary/20 group-hover:scale-110 group-hover:bg-primary/20 transition-all duration-300">
                    {feature.icon}
                  </div>
                  <h3 className="text-lg font-bold tracking-tight mb-1 text-foreground group-hover:text-primary transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    {feature.subtitle}
                  </p>
                </div>

                {}
                {index < features.length - 1 && <div className="hidden md:block absolute top-1/2 -translate-y-1/2 h-1/2 w-px bg-border/50 right-0" style={{
              left: `${(index + 1) * 20}%`
            }} />}
                
                {}
                {index < features.length - 1 && <div className="md:hidden w-full px-8">
                    <Separator className="bg-border/50" />
                  </div>}
              </React.Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}